import Vue from 'vue'
import {reportFields as backend} from "@/api";

export const entryKey = (entry) => {
    switch (entry.source) {
        case 'core':
            return `core|${entry.key}`
        case 'asset_type_custom_field':
            return `asset_type_custom_field|${entry.asset_type_id}|${entry.field_id}`
        case 'site_custom_field':
            return `site_custom_field|${String(entry.label).toLowerCase()}`
        case 'dynamic_status':
            return `dynamic_status|${String(entry.name).toLowerCase()}`
        default:
            return `${entry.source}|${String(entry.label).toLowerCase()}`
    }
}

export default {
    namespaced: true,

    state: {
        reportKeys: [],
        config: {},
        catalogue: null,
        editable: false,
        catalogueFailed: false,
    },

    getters: {
        reportKeys: (state) => state.reportKeys,
        config: (state) => state.config,
        catalogue: (state) => state.catalogue,
        editable: (state) => state.editable,
        catalogueFailed: (state) => state.catalogueFailed,

        unwiredReportKeys: (state) => state.catalogue ? (state.catalogue.unwired_report_keys || []) : [],

        nativeCoreFields: (state) => state.catalogue ? (state.catalogue.native_core_fields || {}) : {},

        selectedKeys: (state) => {
            const index = {}

            Object.keys(state.config).forEach(reportKey => {
                index[reportKey] = new Set((state.config[reportKey] || []).map(entryKey))
            })

            return index
        },
    },

    mutations: {
        setReportFields: (state, payload) => {
            state.reportKeys = payload.report_keys || []
            state.config = payload.report_fields || {}
            state.editable = payload.editable === true
        },
        setCatalogue: (state, payload) => {
            state.catalogue = payload
            state.catalogueFailed = false
        },
        setCatalogueFailed: (state) => {
            state.catalogue = null
            state.catalogueFailed = true
        },
        setReportConfig: (state, {reportKey, entries}) => {
            Vue.set(state.config, reportKey, entries)
        },
        setConfig: (state, payload) => {
            state.config = payload || {}
        },
    },

    actions: {
        load: ({commit}) => new Promise((resolve, reject) => {
            backend.getReportFields(response => {
                commit('setReportFields', response.data)
                resolve()
            }, reject)
        }),

        loadCatalogue: ({commit}) => new Promise((resolve) => {
            backend.getReportFieldCatalogue(response => {
                commit('setCatalogue', response.data)
                resolve()
            }, () => {
                commit('setCatalogueFailed')
                resolve()
            })
        }),

        save: ({commit, state}) => new Promise((resolve, reject) => {
            backend.postReportFields(response => {
                commit('setConfig', response.data.report_fields)
                resolve()
            }, reject, {report_fields: state.config})
        }),
    },
}
